export default __webpack_public_path__ + "static/media/share_svg.fe01159f.svg";